export const API_BONDS = '/elephant-bonds';

export const API_BOND_INFO = `${API_BONDS}/info`;
export const API_BOND_SIGN_MINT = `${API_BONDS}/sign-mint`;
export const API_BOND_SIGN_REDEEM = `${API_BONDS}/sign-redeem`;
export const API_BOND_TOTAL_REWARDS_DISTRIBUTED = `${API_BONDS}/total-rewards-distributed`;
